module.exports = __webpack_public_path__ + "static/media/github.1413f4f4.68b37248.svg";